var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarbonShoppingCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:shopping-cart-arrow-down",
    clipPath: "url(#clip0_118_1896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.625 24.375C9.52246 24.375 10.25 23.6475 10.25 22.75C10.25 21.8526 9.52246 21.125 8.625 21.125C7.72754 21.125 7 21.8526 7 22.75C7 23.6475 7.72754 24.375 8.625 24.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 24.375C20.8975 24.375 21.625 23.6475 21.625 22.75C21.625 21.8526 20.8975 21.125 20 21.125C19.1025 21.125 18.375 21.8526 18.375 22.75C18.375 23.6475 19.1025 24.375 20 24.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.54625 2.27828C4.50945 2.09416 4.41001 1.92847 4.26485 1.80938C4.11969 1.69028 3.93776 1.62514 3.75 1.62503H0.5V3.25003H3.08375L6.20375 18.8468C6.24055 19.0309 6.33999 19.1966 6.48515 19.3157C6.63031 19.4348 6.81224 19.4999 7 19.5H21.625V17.875H7.66625L7.01625 14.625H21.625C21.8098 14.625 21.9891 14.5619 22.1333 14.4463C22.2775 14.3306 22.3779 14.1693 22.418 13.9888L24.2607 5.68753H22.5976L20.9734 13H6.69125L4.54625 2.27828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.0386 5.35116L15.125 8.26478V1.62503H13.5V8.26478L10.5864 5.35116L9.4375 6.50003L14.3125 11.375L19.1875 6.50003L18.0386 5.35116Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_1896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.5 3.05176e-05)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonShoppingCart);
export default __webpack_public_path__ + "static/media/carbon_shopping-cart.664ddc9d4836a92eec9751d54ff30d0b.svg";
export { ForwardRef as ReactComponent };